// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__C98R3","content":"Container_content__9UTFi"};